import React from 'react'
import PropTypes from "prop-types"
import "app/static/stylus/FieldHeader.styl"
import Tooltip from "components/Tooltip"
import Icon from "app/static/frontend/components/Icon"

const FieldHeader = ({ header, tooltip, tooltipLabel }) => (
    <div className="field-header">
        {header || ''}
        {
            tooltip && (
                <Tooltip label={tooltipLabel} placement="right" delayShow={0}>
                    {<Icon className="fa-fw fa-info-circle" id="info-click" />}
                </Tooltip>
            )
        }
    </div>
)

FieldHeader.propTypes = {
    header: PropTypes.string,
    tooltip: PropTypes.bool,
    tooltipLabel: PropTypes.string,
}

export default FieldHeader
